export default __webpack_public_path__ + "static/media/conics.df1e1deb.png";